import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row g-4 mb-4" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "row g-4" }
const _hoisted_6 = { class: "col-lg-12 col-sm-6" }
const _hoisted_7 = { class: "col-lg-12 col-sm-6" }
const _hoisted_8 = { class: "row g-4 mb-4" }
const _hoisted_9 = { class: "col-lg-4" }
const _hoisted_10 = { class: "col-lg-4 col-md-6" }
const _hoisted_11 = { class: "col-lg-4 col-md-6" }
const _hoisted_12 = { class: "row g-4 mb-4" }
const _hoisted_13 = { class: "col-xxl-9" }
const _hoisted_14 = { class: "col-xxl-3" }
const _hoisted_15 = { class: "row g-4" }
const _hoisted_16 = { class: "col-xxl-12 col-sm-6" }
const _hoisted_17 = { class: "col-xxl-12 col-sm-6" }
const _hoisted_18 = { class: "row g-4 mb-4" }
const _hoisted_19 = { class: "col-xxl-4 col-md-12 col-lg-6" }
const _hoisted_20 = { class: "col-xxl-4 col-md-6" }
const _hoisted_21 = { class: "col-xxl-4 col-md-6 col-lg-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyCards = _resolveComponent("MyCards")!
  const _component_TotalBalance = _resolveComponent("TotalBalance")!
  const _component_TotalExpense = _resolveComponent("TotalExpense")!
  const _component_CardsWithAmountChart = _resolveComponent("CardsWithAmountChart")!
  const _component_DailyLimit = _resolveComponent("DailyLimit")!
  const _component_QuickTransfer = _resolveComponent("QuickTransfer")!
  const _component_RecentTransactions = _resolveComponent("RecentTransactions")!
  const _component_CreditUtilizationRatioChart = _resolveComponent("CreditUtilizationRatioChart")!
  const _component_MonthlySpendingChart = _resolveComponent("MonthlySpendingChart")!
  const _component_SpendingBreakdownChart = _resolveComponent("SpendingBreakdownChart")!
  const _component_InterestChargeFeesChart = _resolveComponent("InterestChargeFeesChart")!
  const _component_StatisticsChart = _resolveComponent("StatisticsChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MyCards)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_TotalBalance)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TotalExpense)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_CardsWithAmountChart)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_DailyLimit)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_QuickTransfer)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_RecentTransactions)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_CreditUtilizationRatioChart)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_MonthlySpendingChart)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_SpendingBreakdownChart)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_InterestChargeFeesChart)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_StatisticsChart)
      ])
    ])
  ]))
}